import React from "react";
import PhoneInput from "./PhoneInput";

const TenantStep = ({ tenant, onTenantChange, onEmploymentChange }) => {
  return (
    <>
      <h5 className="mb-3">Tenant Information</h5>

      <div className="row g-3">
        <div className="col-md-6">
          <label className="form-label">First Name</label>
          <input
            type="text"
            className="form-control"
            value={tenant.firstName}
            onChange={(e) => onTenantChange("firstName", e.target.value)}
            required
          />
        </div>
        <div className="col-md-6">
          <label className="form-label">Last Name</label>
          <input
            type="text"
            className="form-control"
            value={tenant.lastName}
            onChange={(e) => onTenantChange("lastName", e.target.value)}
            required
          />
        </div>
        <div className="col-md-6">
          <label className="form-label">Email</label>
          <input
            type="email"
            className="form-control"
            value={tenant.email}
            onChange={(e) => onTenantChange("email", e.target.value)}
            required
          />
        </div>
        <div className="col-md-6">
          <label className="form-label">Mobile Phone</label>
          <PhoneInput
            value={tenant.phoneMobile}
            onChange={(val) => onTenantChange("phoneMobile", val)}
            required
          />
        </div>
        <div className="col-md-6">
          <label className="form-label">Date of Birth</label>
          <input
            type="date"
            className="form-control"
            value={tenant.dateOfBirth}
            onChange={(e) => onTenantChange("dateOfBirth", e.target.value)}
            required
          />
        </div>
        <div className="col-12">
          <label className="form-label">Current Address</label>
          <input
            type="text"
            className="form-control"
            placeholder="Street, City, Area/Region, Postal code"
            value={tenant.address}
            onChange={(e) => onTenantChange("address", e.target.value)}
            required
          />
        </div>
        <div className="col-md-6">
          <label className="form-label">Marital Status</label>
          <select
            className="form-select"
            value={tenant.maritalStatus}
            onChange={(e) => onTenantChange("maritalStatus", e.target.value)}
          >
            <option value="">-- Select --</option>
            <option value="Single">Single</option>
            <option value="Married">Married</option>
            <option value="Divorced">Divorced</option>
            <option value="Widowed">Widowed</option>
            <option value="Separated">Separated</option>
          </select>
        </div>
        <div className="col-md-3">
          <label className="form-label">Number of Children</label>
          <input
            type="number"
            min="0"
            className="form-control"
            value={tenant.numberOfChildren}
            onChange={(e) => onTenantChange("numberOfChildren", e.target.value)}
          />
        </div>
        <div className="col-md-3">
          <label className="form-label">Children's Ages</label>
          <input
            type="text"
            className="form-control"
            placeholder="e.g. 4, 7"
            value={tenant.childrenAges}
            onChange={(e) => onTenantChange("childrenAges", e.target.value)}
          />
        </div>
      </div>

      <hr className="my-4" />

      <h5 className="mb-3">Employment</h5>
      <div className="row g-3">
        <div className="col-md-6">
          <label className="form-label">Employer</label>
          <input
            type="text"
            className="form-control"
            value={tenant.employment.employer}
            onChange={(e) => onEmploymentChange("employer", e.target.value)}
            required
          />
        </div>
        <div className="col-md-6">
          <label className="form-label">Occupation</label>
          <input
            type="text"
            className="form-control"
            value={tenant.employment.occupation}
            onChange={(e) => onEmploymentChange("occupation", e.target.value)}
            required
          />
        </div>
        <div className="col-12">
          <label className="form-label">Employer Address</label>
          <input
            type="text"
            className="form-control"
            value={tenant.employment.employerAddress}
            onChange={(e) =>
              onEmploymentChange("employerAddress", e.target.value)
            }
            required
          />
        </div>
        <div className="col-md-6">
          <label className="form-label">Duration of Employment</label>
          <input
            type="text"
            className="form-control"
            placeholder="e.g. 3 years"
            value={tenant.employment.duration}
            onChange={(e) => onEmploymentChange("duration", e.target.value)}
            required
          />
        </div>
        <div className="col-md-6">
          <label className="form-label">Monthly Income (TTD)</label>
          <input
            type="number"
            className="form-control"
            min="0"
            value={tenant.employment.monthlyIncome}
            onChange={(e) =>
              onEmploymentChange("monthlyIncome", e.target.value)
            }
            required
          />
        </div>
        <div className="col-md-6">
          <label className="form-label">Work Phone</label>
          <PhoneInput
            value={tenant.employment.workPhone}
            onChange={(val) => onEmploymentChange("workPhone", val)}
          />
        </div>
      </div>
    </>
  );
};

export default TenantStep;


